// extracted by mini-css-extract-plugin
export var fadeIn = "index-module--fadeIn--06b97";
export var hero = "index-module--hero--7a0c6";
export var heroContainer = "index-module--heroContainer--d571d";
export var heroTitle = "index-module--heroTitle--5ca0a";
export var wholePageEditButton = "index-module--wholePageEditButton--65162";